import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Houston",
    route: "/cities/houston",
    tagline: "Houston's premier expedited passport processing hub",
    highlights: ["Houston metro area coverage", "Serving The Woodlands, Sugar Land, Katy"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Dallas",
    route: "/cities/dallas",
    tagline: "North Texas expedited passport services",
    highlights: ["Dallas-Fort Worth metroplex", "Serving Plano, Frisco, Irving"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Austin",
    route: "/cities/austin",
    tagline: "Central Texas expedited passport processing",
    highlights: ["Travis County coverage", "Serving Round Rock, Cedar Park, Georgetown"],
    badge: null,
    status: "live",
  },
  {
    name: "San Antonio",
    route: "/cities/san-antonio",
    tagline: "South Texas expedited passport services",
    highlights: ["Bexar County coverage", "Serving New Braunfels, Schertz, Converse"],
    badge: null,
    status: "live",
  },
  {
    name: "Fort Worth",
    route: "/cities/fort-worth",
    tagline: "Tarrant County expedited passport processing",
    highlights: ["Fort Worth area coverage", "Serving Arlington, Grapevine, Keller"],
    badge: null,
    status: "live",
  },
  {
    name: "El Paso",
    route: "/cities/el-paso",
    tagline: "West Texas border expedited passport services",
    highlights: ["El Paso County coverage", "Serving Horizon City, Socorro, Clint"],
    badge: null,
    status: "live",
  },
  {
    name: "Arlington",
    route: "/cities/arlington",
    tagline: "Tarrant County expedited passport services",
    highlights: ["Arlington area coverage", "Serving Grand Prairie, Mansfield, Kennedale"],
    badge: null,
    status: "live",
  },
  {
    name: "Corpus Christi",
    route: "/cities/corpus-christi",
    tagline: "Coastal Bend expedited passport processing",
    highlights: ["Nueces County coverage", "Serving Portland, Robstown, Flour Bluff"],
    badge: null,
    status: "live",
  },
  {
    name: "Plano",
    route: "/cities/plano",
    tagline: "Collin County expedited passport services",
    highlights: ["Plano area coverage", "Serving Allen, Richardson, Murphy"],
    badge: null,
    status: "live",
  },
  {
    name: "Laredo",
    route: "/cities/laredo",
    tagline: "South Texas border expedited passport services",
    highlights: ["Webb County coverage", "Serving Rio Bravo, El Cenizo"],
    badge: null,
    status: "live",
  },
  {
    name: "Lubbock",
    route: "/cities/lubbock",
    tagline: "West Texas expedited passport processing",
    highlights: ["Lubbock County coverage", "Serving Wolfforth, Shallowater"],
    badge: null,
    status: "live",
  },
  {
    name: "Garland",
    route: "/cities/garland",
    tagline: "Dallas County expedited passport services",
    highlights: ["Garland area coverage", "Serving Rowlett, Sachse, Wylie"],
    badge: null,
    status: "live",
  },
  {
    name: "Irving",
    route: "/cities/irving",
    tagline: "Dallas County expedited passport processing",
    highlights: ["Irving area coverage", "Serving Las Colinas, Valley Ranch, Coppell"],
    badge: null,
    status: "live",
  },
  {
    name: "Amarillo",
    route: "/cities/amarillo",
    tagline: "Panhandle expedited passport services",
    highlights: ["Potter & Randall County coverage", "Serving Canyon, Bushland"],
    badge: null,
    status: "live",
  },
  {
    name: "Grand Prairie",
    route: "/cities/grand-prairie",
    tagline: "Dallas County expedited passport processing",
    highlights: ["Grand Prairie area coverage", "Serving Arlington, Irving, Mansfield"],
    badge: null,
    status: "live",
  },
  {
    name: "Brownsville",
    route: "/cities/brownsville",
    tagline: "Rio Grande Valley expedited passport services",
    highlights: ["Cameron County coverage", "Serving Harlingen, San Benito, Los Fresnos"],
    badge: null,
    status: "live",
  },
  {
    name: "McKinney",
    route: "/cities/mckinney",
    tagline: "Collin County expedited passport processing",
    highlights: ["McKinney area coverage", "Serving Allen, Prosper, Melissa"],
    badge: null,
    status: "live",
  },
  {
    name: "Frisco",
    route: "/cities/frisco",
    tagline: "Collin & Denton County expedited passport services",
    highlights: ["Frisco area coverage", "Serving Little Elm, The Colony, Prosper"],
    badge: null,
    status: "live",
  },
  {
    name: "Pasadena",
    route: "/cities/pasadena-tx",
    tagline: "Harris County expedited passport processing",
    highlights: ["Pasadena area coverage", "Serving Deer Park, La Porte, South Houston"],
    badge: null,
    status: "live",
  },
  {
    name: "Mesquite",
    route: "/cities/mesquite",
    tagline: "Dallas County expedited passport services",
    highlights: ["Mesquite area coverage", "Serving Balch Springs, Sunnyvale, Garland"],
    badge: null,
    status: "live",
  },
  {
    name: "Killeen",
    route: "/cities/killeen",
    tagline: "Central Texas expedited passport processing near Fort Cavazos",
    highlights: ["Bell County coverage", "Serving Harker Heights, Copperas Cove, Temple"],
    badge: null,
    status: "live",
  },
  {
    name: "McAllen",
    route: "/cities/mcallen",
    tagline: "Rio Grande Valley expedited passport services",
    highlights: ["Hidalgo County coverage", "Serving Edinburg, Mission, Pharr"],
    badge: null,
    status: "live",
  },
  {
    name: "Waco",
    route: "/cities/waco",
    tagline: "Central Texas expedited passport processing",
    highlights: ["McLennan County coverage", "Serving Hewitt, Woodway, Bellmead"],
    badge: null,
    status: "live",
  },
  {
    name: "Denton",
    route: "/cities/denton",
    tagline: "North Texas expedited passport services",
    highlights: ["Denton County coverage", "Serving Lewisville, Flower Mound, Corinth"],
    badge: null,
    status: "live",
  },
  {
    name: "Midland",
    route: "/cities/midland-tx",
    tagline: "Permian Basin expedited passport processing",
    highlights: ["Midland County coverage", "Serving Odessa, Andrews"],
    badge: null,
    status: "live",
  },
  {
    name: "Carrollton",
    route: "/cities/carrollton-tx",
    tagline: "Dallas & Denton County expedited passport services",
    highlights: ["Carrollton area coverage", "Serving Farmers Branch, Addison, Coppell"],
    badge: null,
    status: "live",
  },
  {
    name: "Abilene",
    route: "/cities/abilene",
    tagline: "West Central Texas expedited passport processing",
    highlights: ["Taylor & Jones County coverage", "Serving Dyess AFB area"],
    badge: null,
    status: "live",
  },
  {
    name: "Beaumont",
    route: "/cities/beaumont",
    tagline: "Southeast Texas expedited passport services",
    highlights: ["Jefferson County coverage", "Serving Port Arthur, Nederland, Lumberton"],
    badge: null,
    status: "live",
  },
  {
    name: "Round Rock",
    route: "/cities/round-rock",
    tagline: "Austin metro expedited passport processing",
    highlights: ["Williamson County coverage", "Serving Pflugerville, Cedar Park, Leander"],
    badge: null,
    status: "live",
  },
  {
    name: "Odessa",
    route: "/cities/odessa",
    tagline: "Permian Basin expedited passport services",
    highlights: ["Ector County coverage", "Serving Midland, Andrews, Monahans"],
    badge: null,
    status: "live",
  },
  {
    name: "Wichita Falls",
    route: "/cities/wichita-falls",
    tagline: "North Texas expedited passport processing near Sheppard AFB",
    highlights: ["Wichita County coverage", "Serving Burkburnett, Iowa Park"],
    badge: null,
    status: "live",
  },
  {
    name: "Richardson",
    route: "/cities/richardson",
    tagline: "Telecom Corridor expedited passport services near UTD",
    highlights: ["Collin & Dallas County coverage", "Serving Plano, Garland, Allen"],
    badge: null,
    status: "live",
  },
  {
    name: "Tyler",
    route: "/cities/tyler",
    tagline: "East Texas expedited passport processing",
    highlights: ["Smith County coverage", "Serving Whitehouse, Lindale, Bullard"],
    badge: null,
    status: "live",
  },
  {
    name: "Lewisville",
    route: "/cities/lewisville",
    tagline: "Denton County expedited passport services",
    highlights: ["Lewisville area coverage", "Serving Flower Mound, Highland Village, The Colony"],
    badge: null,
    status: "live",
  },
  {
    name: "Pearland",
    route: "/cities/pearland",
    tagline: "Brazoria County expedited passport processing",
    highlights: ["Pearland area coverage", "Serving Friendswood, Manvel, Alvin"],
    badge: null,
    status: "live",
  },
  {
    name: "San Angelo",
    route: "/cities/san-angelo",
    tagline: "West Central Texas expedited passport services",
    highlights: ["Tom Green County coverage", "Serving Goodfellow AFB area, Wall"],
    badge: null,
    status: "live",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function TexasCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Texas Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Texas Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">&quot;{searchQuery}&quot;</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Texas</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We&apos;re always adding new Texas locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}